import {Box, Image, Show} from 'platform/foundation';

import {isNotNil} from 'ramda';

import type {OptionTypeBase} from '../../../types/OptionTypeBase';
import {StatusIndicatorDot} from './StatusIndicatorDot';

export function ChoiceAvatarImage<ValueType>(props: {
  src: string | null | undefined;
  option?: OptionTypeBase<ValueType>;
}) {
  return (
    <Box position="relative" flexShrink={0}>
      <Image src={props.src} height={6} width={6} borderRadius="circular" isLazy hasSpinner />
      <Show when={isNotNil(props.option?.statusIndicator)}>
        <StatusIndicatorDot statusIndicator={props.option?.statusIndicator} isOverAvatar />
      </Show>
    </Box>
  );
}
